import { getLastTherapist } from "@/Services/TherapyApi/Users";
import UserApiToUserTransformer from "@/Modules/Transformers/User/UserApiToUserTransformer";

import useUserStore from "@/Modules/User/Store";

import { danger } from "@/Utils/Debug";

async function setLastTherapistAH(): Promise<void> {
  const userStore = useUserStore();
  const userApiToUserTransformer = new UserApiToUserTransformer();

  userStore.isLoading = true;
  try {
    const lastTherapistData = await getLastTherapist();

    userStore.lastTherapist = userApiToUserTransformer.transform(lastTherapistData);
  } catch (error) {
    danger(error);
  } finally {
    userStore.isLoading = false;
  }
}

export default setLastTherapistAH;
